import { status } from "skin/event/status";
import table from "./table";
import api from "skin/http";

//Отправка запроса на сервер и получение данных для отрисовки таблицы
const msStat = (obj, ms, story, data, d, action) => {
  if (obj.action === "loadData")
    return new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: "api/other/master/getPc",
      };
      api(config)
        .then((res) => {
          // if (data.curData.values.table.tnk_stat.list.length) return resolve(status.action);
          const arr = [];
          //   для отображения строк в таблице
          res.data.forEach((el) => {
            if (el?.isStat) arr.push(el?.ip);
            // "", el._id, el?.ip, el?.cmp, el.bld - чек, id терминала(скрыто), ip терминала, привязка к компании терминала, привязка к складу терминала
            data.addRow(ms, "tnk_stat", { key: el._id, list: ["", el._id, el?.ip, el?.cmp ?? "", `${el.bld}`, el?.cmpId] });
          });

          //   для подстановки "" или "+" в первой строке в зависимости есть ли запись isStat в данных
          const check = data.curData.values.fld.ip;
          data.curData.values.table.tnk_stat.list.forEach((el) => {
            const ip = el?.list[2];
            if (check.includes(ip)) {
              if (arr.includes(ip)) data.setCell("tnk_stat", el.key, 0, "+");
              else data.setCell("tnk_stat", el.key, 0, "");
            }
          });
          return resolve(status.action);
        })
        .catch((err) => {
          return resolve(status.action);
        });
    });
  switch (obj.type) {
    case "table":
      return table(obj, ms, story, data, d, action);
    default:
      return status.action;
  }
};

export default msStat;
